import {text_mod_10, } from "../text/Text.js";
export const module10 = {
  title:
    "§10. Наголос.​ Зміна значення слова зі зміною наголосу​​",
  questions: [
    {
      id: 1,
      onlyText: true,
      text: text_mod_10, },
    ]
  }
